import { window, exists } from 'browser-monads'

class FbInit {
    static addIfNeeded() {
        if(exists(window)) {
            if(!("addedFbScript" in window)) {
                let script = document.createElement("script");

                script.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v8.0&appId=393692007923969&autoLogAppEvents=1";
                script.async = true;
                script.defer = true;
                script.crossOrigin = "anonymous"
                script.nonce = "xlWHOwhW"

                document.body.appendChild(script);

                window.addedFbScript = true;
            }
        }
    }
}

export default FbInit;